import gql from 'graphql-tag';
import { API } from 'aws-amplify';
import { graphqlOperation } from '@aws-amplify/api';
import { GiidePasswordAction, GiidePasswordOutput } from '../../graphql/api';
import { useSelector } from 'react-redux';
import { IState } from '../../graphql/types';

const passwordMutation = gql`
  mutation passwordMutation(
    $giideId: ID!
    $action: GiidePasswordAction
    $password: String!
  ) {
    handleGiidePasswords(
      input: { giideId: $giideId, action: $action, password: $password }
    ) {
      success
      error
    }
  }
`;

const useGiidePasswordOperation = () => {
  const isEnabled = useSelector<IState>(
    state =>
      !!state.user?.plan.features?.giidePasswordProtection
        ?.allowGiidePasswordProtection
  );

  const passwordOperation = async (
    giideId: string | null,
    action: GiidePasswordAction,
    password: string
  ) => {
    const result = await (API.graphql(
      graphqlOperation(passwordMutation, {
        giideId: giideId,
        action: action,
        password: password,
      })
    ) as Promise<{ data: { handleGiidePasswords: GiidePasswordOutput } }>);

    return result.data?.handleGiidePasswords;
  };

  return {
    isEnabled,
    passwordOperation,
  };
};

export default useGiidePasswordOperation;
